module.exports = __webpack_public_path__ + "img/sport_water.bb7e3da6.svg";